<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      class="px-2 py-4"
      app
    >
    <v-row class="py-2">
        <v-col class="col-12 text-center">
            <img src="../../assets/africanring.jpeg" width="150"/>
        </v-col>
    </v-row>
      <v-list dense>
        <v-list-item-group
            dark
            v-model="selectedItem"
            color="red"
        >
            <v-list-item
            v-for="(item, i) in items"
            :key="i" @click="menuActionClick(item.action)"
            >
            <v-list-item-icon>
                   <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
            </v-list-item>
        </v-list-item-group>
        </v-list>
        <!-- <a @click.prevent.stop="logout">Logout</a> -->
    </v-navigation-drawer>

    <v-app-bar app flat color="transparent">
      <v-app-bar-nav-icon @click="drawer = !drawer" class="white--text"></v-app-bar-nav-icon>

      <v-toolbar-title class="white--text">African Ring</v-toolbar-title>
    </v-app-bar>
  </div>
</template>

<script>
import firebase from 'firebase/compat/app';

export default {
  name: 'App',

  data: () => ({
      drawer: null,
      selectedItem: 0,
        items: [
            { text: 'Home', icon: 'mdi-view-dashboard', action: 'home' },
            { text: 'Fighters', icon: 'mdi-account-multiple', action: 'fighters' },
            { text: 'Fights', icon: 'mdi-account-switch', action: 'fights' },
            { text: 'Logout', icon: 'mdi-logout-variant', action: 'logout' },
            // { text: 'Conversions', icon: 'mdi-flag' },
        ],
    //
  }),
  methods: {
         logout(){
            firebase.auth().signOut().then(() => {
              let signedin = false;
              let user = {}
              let fighters = []

              this.$store.dispatch('setUser', user);
              this.$store.dispatch('setSignedIn', signedin);
              this.$store.dispatch('setsetgetallfightersNull', fighters);
              this.$router.replace('/');
            });
         },
         menuActionClick(action) {
             if(action == 'logout') {
                this.logout()
             } else if (action == 'home') {
                 this.$router.push('/home');
             } else if (action == 'fighters') {
                 this.$router.push('fighters');
             }
             else if (action == 'fights') {
                 this.$router.push('fights');
             }
         }
      }
};
</script>

<style lang="sass">

.v-navigation-drawer
  background-color: #000000 !important

</style>